import CardPillLabel from "../../components/ui/CardPillLabel";
import { IconMail, IconPhone, IconX } from "../../components/ui/Icons";
import { useBodyScrollLock } from "../../hooks/useBodyScrollLock";
import { useHeaderBehindModal } from "../../hooks/useHeaderBehindModal";
import KevinCardImg from "../../assets/placeholders/KevinCardPhoto.png";
import { useEscapeKey } from "../media/components/useEscapeKey";

const guideCard = {
  title: "Przewodnik historyczny",
  name: "Robert Nowakowski",
  role: "Przewodnik",
  phone: "+48 609 365 547",
  email: "kerin@kerin.pl",
  image: KevinCardImg,
  lead:
    "Nazywam się Robert Nowakowski i zapraszam Cię do wspólnej podróży przez historię.\n\n" +
    "Nie jestem tylko przewodnikiem tej trasy. Jestem jej częścią. Opowiadam historię tak, jak ją rozumiem, czuję i przeżywam. To nie jest opowieść o datach i wydarzeniach, ale o ludziach, wyborach i wartościach, które kształtują nas do dziś.\n\n" +
    "Wierzę, że historia powinna budzić ciekawość. To ona pozwala lepiej zrozumieć świat, siebie i drogę, którą każdy z nas idzie.\n\n" +
    "Ta trasa nie jest tylko spacerem. To zaproszenie do refleksji, zadawania pytań i odkrywania własnych odpowiedzi.\n\n" +
    "To moja opowieść. Ty możesz odkryć w niej swoją.",
};

export default function BusinessCardModal({ open, onClose }) {
  useBodyScrollLock(open);
  useHeaderBehindModal(open);
  useEscapeKey(() => {
    if (open) onClose?.();
  });

  if (!open) return null;

  return (
    <div
      className="businessCardModalBackdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="guide-modal-title"
      onClick={onClose}
    >
      <div
        className="businessCardModalShell"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="imgModalHd businessCardModalHeader">
          <div className="imgModalTitle businessCardModalHeaderText">
            Wizytówka przewodnika
          </div>
          <button
            type="button"
            className="modalCloseBtn businessCardCloseBtn"
            onClick={onClose}
            aria-label="Zamknij wizytówkę przewodnika"
          >
            <IconX />
          </button>
        </div>

        <div className="businessCardModalBody">
          <div className="card cardLabeled businessCardModalCard">
            <CardPillLabel text="Przewodnik" variant="kontakt" />

            <div className="businessCardTop">
              <div className="businessCardTopText">
                <h2 id="guide-modal-title" className="h1">
                  {guideCard.name}
                </h2>
              </div>

              <div className="businessCardAvatarWrap">
                <img
                  src={guideCard.image}
                  alt={guideCard.name}
                  className="businessCardAvatar"
                />
              </div>
            </div>

            <div className="mutedSmall businessCardLead">
              {guideCard.lead.split("\n\n").map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>

            <div className="contactPageGrid">
              <div className="contactPageCard">
                <h3 className="contactMiniTitle">{guideCard.title}</h3>

                <div className="contactMiniRow">
                  <div className="contactMiniLabel">Imię</div>
                  <div className="contactMiniValue">{guideCard.name}</div>
                </div>

                <div className="contactMiniRow">
                  <div className="contactMiniLabel">Rola</div>
                  <div className="contactMiniValue">{guideCard.role}</div>
                </div>

                <a
                  className="contactMiniRow link"
                  href={`tel:${guideCard.phone.replace(/\s+/g, "")}`}
                >
                  <div className="contactLineIcon">
                    <IconPhone />
                  </div>
                  <div>
                    <span className="contactLineLabel">Telefon</span>
                    <span className="contactLineValue">{guideCard.phone}</span>
                  </div>
                </a>

                <a
                  className="contactMiniRow link"
                  href={`mailto:${guideCard.email}`}
                >
                  <div className="contactLineIcon">
                    <IconMail />
                  </div>
                  <div>
                    <span className="contactLineLabel">Email</span>
                    <span className="contactLineValue">{guideCard.email}</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}